/** 前回の手札ID列と今回の手札ID列から、新しく現れたカードIDを手札内の並び順で返す。 */
export function newlyDealtIds(
  previousIds: readonly string[],
  nextIds: readonly string[],
): string[] {
  const known = new Set(previousIds);
  return nextIds.filter((id) => !known.has(id));
}
